import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import styled from 'styled-components';

const MeetBigCats = ({ categoryId }) => {
  const { merchantid } = useParams();
  const [data, setData] = useState([]);
  const [showDummy, setShowDummy] = useState(false);

  // Dummy fallback array
  const arraydata = [
    { id: 1, imageMediumBase64: "/images/image-600x800.jpg", price: "0.00", productName: "Product Name" },
    { id: 2, imageMediumBase64: "/images/image-600x800.jpg", price: "0.00", productName: "Product Name" },
    { id: 3, imageMediumBase64: "/images/image-600x800.jpg", price: "0.00", productName: "Product Name" },
    { id: 4, imageMediumBase64: "/images/image-600x800.jpg", price: "0.00", productName: "Product Name" },
  ];

  useEffect(() => {
    const fetchApproved = async () => {
      try {
        const res = await axios.get(
          `https://api.bakpoket.com/api/AdminContent/products/approved`
        );

        if (res.data && res.data.length > 0) {
          // ✅ Filter only items where merchantURL last part equals merchantid
          const filtered = res.data.filter((item) => {
            if (!item.merchantURL) return false;
            const parts = item.merchantURL.split('/');
            
            const lastPart = parts[parts.length - 1];
            // console.log(lastPart, merchantid);
            return lastPart === merchantid;
          });

          if (filtered.length > 0) {
            setData(filtered);      // ✅ Set actual products
            // console.log(filtered)
            setShowDummy(false);    // ✅ Show real data
          } else {
            setShowDummy(true);     // ❌ No match → dummy
          }
        } else {
          setShowDummy(true);
        }
      } catch (err) {
        console.log(err);
        setShowDummy(true);
      }
    };

    fetchApproved();
  }, [merchantid]);

  return (
    <Wrapper>
      <div className="container">
        <div
          className="container d-flex align-items-center justify-content-center mb-1"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.99)' }}
        >
          <h2 className="text-light display-4 display-lg-3 fw-bold py-3 py-lg-4 py-xlg-5">
            HOME PRODUCTS
          </h2>
        </div>

        <div className="row my-3">
          {showDummy ? (
            <AdGrid>
              {arraydata.map((ad) => (
                <AdCard key={`dummy-${ad.id}`}>
                  <div>
                    <img src={ad.imageMediumBase64} alt={ad.productName} style={{ width: '100%' }} />
                    <h6 className="my-2 fw-bold">{ad.productName}</h6>
                    <h5 className="mb-2">Rs. {ad.price}</h5>
                    <button className="btn rounded w-100 mx-auto fs-5">Buy Now</button>
                  </div>
                </AdCard>
              ))}
            </AdGrid>
          ) : data.length > 0 ? (
            <AdGrid>
              {data.map((ad) => (
                <AdCard key={`ad-${ad.id}`}>
                  <div>
                    <img
                      src={`${ad.imageData}`}
                      alt={ad.productName}
                      style={{ width: '100%',aspectRatio: "270 / 255",
    objectFit: "cover" }}
                    />
                    <h6 className="product-name my-2 fw-bold">{ad.productName}</h6>
                    <h5 className="mb-2">Rs. {ad.price}.00</h5>
                    <NavLink to={`/payment/${ad.price}`}>
                      <button className="btn rounded w-100 mx-auto fs-5">Buy Now</button>
                    </NavLink>
                  </div>
                </AdCard>
              ))}
            </AdGrid>
          ) : (
            <Para>Loading...</Para>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

export default MeetBigCats;

// ---------- Styled Components ----------
const Wrapper = styled.section`
  h4 {
    margin-left: 30px;
  }

  @media (max-width: 576px) {
    h4 {
      margin-left: 0px;
    }
  }
`;

const AdGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  max-width: 1280px;
  margin: 0 auto;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
  }
`;

const AdCard = styled.div`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
  padding: 5px;

  img {
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }

  .product-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    min-height: 3em;
    line-height: 1.5em;
  }
`;

const Para = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #666;
`;
